export const cleanGPI = (gpi) => gpi?.replaceAll(/[^a-z|\d]/gi, '');
